import { FORM_STATE, MODE, useFormStore } from "../../stores/formStore";

const useIsFieldDisabled = (disabled: boolean, disabledForEdit: boolean) => {
  const { formMode, formState } = useFormStore(state => ({
    formMode: state.mode,
    formState: state.formState,
  }));

  const isViewMode = formMode === MODE.VIEW;
  const isAlwaysDisabled = disabled;
  const isPrefilledDisabled = disabledForEdit && formState === FORM_STATE.SAVED;

  return isViewMode || isAlwaysDisabled || isPrefilledDisabled;
};

export default useIsFieldDisabled;
